const downloadSrc = async (src, filename) => {
  const image = await fetch(src, { cors: 'cors', cache: 'no-cache' });
  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);

  const link = document.createElement('a');
  link.href = imageURL;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadSrc;
